var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopyApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1668 9.09967V11.8997C10.1668 13.017 9.9403 13.6691 9.55494 14.0545C9.16959 14.4398 8.51752 14.6663 7.40016 14.6663H4.60016C3.48281 14.6663 2.83074 14.4398 2.44538 14.0545C2.06003 13.6691 1.8335 13.017 1.8335 11.8997V9.09967C1.8335 7.98232 2.06003 7.33025 2.44538 6.94489C2.83074 6.55954 3.48281 6.33301 4.60016 6.33301H7.40016C8.51752 6.33301 9.16959 6.55954 9.55494 6.94489C9.9403 7.33025 10.1668 7.98232 10.1668 9.09967Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59984 2.33301H11.3998C12.5172 2.33301 13.1693 2.55954 13.5546 2.94489C13.94 3.33025 14.1665 3.98232 14.1665 5.09967V7.89967C14.1665 8.81661 14.0122 9.42167 13.7435 9.81948C13.4879 10.1977 13.0831 10.4551 12.416 10.5788C12.3144 10.5977 12.2208 10.5677 12.1421 10.4931C12.059 10.4144 11.9998 10.2899 11.9998 10.1478V9.09967C11.9998 7.63194 11.6598 6.4525 10.8534 5.64612C10.047 4.83974 8.86758 4.49967 7.39984 4.49967H6.35175C6.20965 4.49967 6.08513 4.4405 6.00645 4.35744C5.93184 4.27868 5.90183 4.18511 5.92068 4.08349C6.04445 3.41643 6.30185 3.0116 6.68004 2.75606C7.07785 2.48727 7.68291 2.33301 8.59984 2.33301Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyApi);
export default __webpack_public_path__ + "static/media/ic-copy-api.b13a8ba0c918e7e21f1c56702f1ef9bb.svg";
export { ForwardRef as ReactComponent };